import { CombinedState, combineReducers } from 'redux';

import dataReducer, { IDataState } from './data/data.reducer';
import declineReducer, { IDeclineState } from './decline/decline.reducer';
import thanksReducer, { IThanksState } from './thanks/thanks.reducer';
import { giftFlow, TGiftFlowState } from './giftFlow/giftFlow.reducer';
import { meeting, IMeetingState } from './meeting/meeting.reducer';
import { bookedMeetingInfo, TBookedMeetingInfoState } from './bookedMeetingInfo/bookedMeetingInfo.reducer';
import finishInfoReducer, { IFinishInfoState } from './finishInfo/finishInfo.reducer';
import statusesReducer, { IStatusesState } from './statuses/statuses.reducer';
import actionsReducer, { IRequiredActionsState } from './requiredActions/requiredActions.reducer';
import { shipping, IShippingState } from './shipping/shipping.reducer';
import claimReducer, { IClaimState } from './claim/claim.reducer';
import redirectReducer, { IRedirectState } from './redirect/redirect.reducer';
import { address, TAddressState } from './address/address.reducer';
import {
  oneTimeCodeVerificationSlice,
  TOneTimeCodeVerificationState,
} from './oneTimeCodeVerification/oneTimeCodeVerification.reducer';

export interface IRecipientState {
  data: IDataState;
  decline: IDeclineState;
  thanks: IThanksState;
  giftFlow: TGiftFlowState;
  meeting: IMeetingState;
  bookedMeetingInfo: TBookedMeetingInfoState;
  finishInfo: IFinishInfoState;
  statuses: IStatusesState;
  requiredActions: IRequiredActionsState;
  shipping: IShippingState;
  claim: IClaimState;
  redirect: IRedirectState;
  address: TAddressState;
  [oneTimeCodeVerificationSlice.name]: TOneTimeCodeVerificationState;
}

export const recipient = combineReducers<CombinedState<IRecipientState>>({
  data: dataReducer,
  decline: declineReducer,
  thanks: thanksReducer,
  giftFlow,
  meeting,
  bookedMeetingInfo,
  finishInfo: finishInfoReducer,
  statuses: statusesReducer,
  requiredActions: actionsReducer,
  shipping,
  claim: claimReducer,
  redirect: redirectReducer,
  address,
  oneTimeCodeVerification: oneTimeCodeVerificationSlice.reducer,
});
